// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery, BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { ENV_API_URL } from "config/config";
import { getAccessToken } from "utils/okta";

export interface IToken {
  exp: number;
}

const baseQuery = fetchBaseQuery({
  baseUrl: ENV_API_URL,
  prepareHeaders: async (headers) => {
    const token = (await getAccessToken())?.accessToken;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  return await baseQuery(args, api, extraOptions);
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "AuthorizeUserDetails",
    "Categories",
    "ElasticityCurve",
    "Folders",
    "Features",
    "HomePageData",
    "HomePageFiltersData",
    "DisplayData",
    "MstrCategories",
    "IncentiveCurve",
    "Markets",
    "Products",
    "PricingSimGetProductDetails",
    "PricingSimGetProductPriceDetails",
    "PricingSimGetMetrics",
    "Results",
    "Scenarios",
    "Simulations",
    "SimulationBrandLadderKpi",
    "VolumeDecomp",
    "VolumeFlow",
    "Charts",
    "PriceElasticitiesData",
    "DropDownData",
  ],
  endpoints: () => ({}),
});
